import { Link } from "react-router";
import { useWhoAmI } from "../hooks/useOpsApi";
import { buildLoginUrl } from "../utils/auth";
import CalibrationDialNav from "../components/CalibrationDialNav";

const LOGIN_REDIRECT_PATH = "/ops";

function BrandMark() {
  return (
    <div className="flex items-center gap-3">
      <svg width="44" height="44" viewBox="0 0 175.27 175.27" className="flex-shrink-0">
        <path fill="#1f3a32" d="M87.61,22.45c-35.74,0-64.82,29.08-64.82,64.82s29.08,64.82,64.82,64.82,64.82-29.08,64.82-64.82S123.35,22.45,87.61,22.45M87.61,163.49c-42.03,0-76.23-34.19-76.23-76.22S45.58,11.04,87.61,11.04s76.23,34.19,76.23,76.23-34.19,76.22-76.23,76.22"/>
        <path fill="#1f3a32" d="M87.61,44.78c-23.43,0-42.49,19.06-42.49,42.49s19.06,42.49,42.49,42.49,42.49-19.06,42.49-42.49-19.06-42.49-42.49-42.49M87.61,141.17c-29.72,0-53.9-24.18-53.9-53.9s24.18-53.9,53.9-53.9,53.9,24.18,53.9,53.9-24.18,53.9-53.9,53.9"/>
      </svg>
      <div>
        <div className="text-fl-forest font-light text-sm tracking-[0.3em] uppercase">Fraser Lever</div>
        <div className="text-fl-evergreen font-semibold text-xl tracking-[0.24em] uppercase">AIM Portal</div>
      </div>
    </div>
  );
}

export default function LandingPage() {
  const whoAmIQuery = useWhoAmI();
  const user = whoAmIQuery.data?.user ?? null;
  const isLoading = whoAmIQuery.isLoading;

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_right,_rgba(31,58,50,0.04),_transparent_40%),linear-gradient(180deg,_#ffffff_0%,_#fbf9f0_100%)] text-fl-evergreen">
      <div className="mx-auto flex min-h-screen max-w-7xl flex-col px-6 py-8 lg:px-10">
        <header className="flex items-center justify-between py-4">
          <BrandMark />
          <div className="flex items-center gap-3 text-sm font-medium">
            {isLoading ? (
              <div className="h-10 w-48 animate-pulse rounded-full border border-fl-evergreen/10 bg-fl-evergreen/10" />
            ) : user ? (
              <>
                <span className="rounded-full border border-fl-evergreen/15 bg-fl-evergreen/8 px-3 py-1 text-fl-evergreen">
                  {user.userPrincipal}
                </span>
                <Link
                  to="/ops"
                  className="rounded-full border border-fl-evergreen/30 bg-fl-evergreen/10 px-4 py-2 text-fl-evergreen transition-colors hover:bg-fl-evergreen/18"
                >
                  Open Portal
                </Link>
                <a
                  href="/.auth/logout?post_logout_redirect_uri=/"
                  className="rounded-full border border-fl-evergreen/20 px-4 py-2 text-fl-evergreen/70 transition-colors hover:bg-fl-evergreen/8 hover:text-fl-evergreen"
                >
                  Sign Out
                </a>
              </>
            ) : (
              <a
                  href={buildLoginUrl(LOGIN_REDIRECT_PATH)}
                className="rounded-full border border-fl-evergreen/30 bg-fl-evergreen/10 px-4 py-2 text-fl-evergreen transition-colors hover:bg-fl-evergreen/18"
              >
                Sign In
              </a>
            )}
          </div>
        </header>

        <main className="grid flex-1 items-center gap-10 py-12 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16">
          <section className="min-w-0">
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-fl-forest">
              Condition, defects, and operational visibility
            </p>
            <h1 className="text-5xl font-semibold leading-tight text-fl-evergreen lg:text-6xl">
              Access your assets.
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-fl-evergreen/75">
              The AIM portal is the front door for all fraserlever asset management information and insights.
            </p>

            {!isLoading && !user && (
              <div className="mt-10">
                <a
                  href={buildLoginUrl(LOGIN_REDIRECT_PATH)}
                  className="rounded-full bg-fl-sand px-6 py-3 text-base font-semibold text-fl-evergreen transition-transform hover:-translate-y-0.5"
                >
                  Sign In To Continue
                </a>
              </div>
            )}
          </section>

          <section className="flex min-w-0 items-center justify-center lg:justify-end">
            <CalibrationDialNav />
          </section>
        </main>
      </div>
    </div>
  );
}